import { initializeApp, deleteApp } from 'firebase/app';
import { getAuth, createUserWithEmailAndPassword, signOut } from 'firebase/auth';
import { db, firebaseConfig } from './firebase';
import { collection, getDocs, doc, updateDoc, deleteDoc, setDoc } from 'firebase/firestore';

export const adminService = {
  // Crear nuevo usuario (solo admin) sin desloguear al admin en sesión
  async createUser({ email, password, nombre, rol, departamento = '', sucursalId = '' }) {
    let secondaryApp = null;
    try {
      const appName = `SecondaryAuth_${Date.now()}_${Math.random().toString(36).substring(2, 7)}`;
      secondaryApp = initializeApp(firebaseConfig, appName);
      const secondaryAuth = getAuth(secondaryApp);

      const userCredential = await createUserWithEmailAndPassword(secondaryAuth, email, password);
      const uid = userCredential.user.uid;

      await signOut(secondaryAuth);
      await deleteApp(secondaryApp);
      secondaryApp = null;

      await setDoc(doc(db, 'usuarios', uid), {
        email,
        nombre,
        rol,
        departamento,
        sucursalId,
        activo: true,
        faceRegistered: false,
        fechaRegistro: new Date()
      });

      return { success: true, uid };
    } catch (error) {
      if (secondaryApp) {
        try {
          await deleteApp(secondaryApp);
        } catch (e) {
          // Ignorar error al limpiar
        }
      }
      return { success: false, error: error.message };
    }
  },

  // Obtener lista de usuarios
  async getUsers() {
    try {
      const snapshot = await getDocs(collection(db, 'usuarios'));
      return snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
    } catch (error) {
      throw error;
    }
  },

  // Actualizar rol o estado de un usuario
  async updateUser(userId, data) {
    try {
      await updateDoc(doc(db, 'usuarios', userId), data);
      return { success: true };
    } catch (error) {
      return { success: false, error: error.message };
    }
  },

  // Eliminar usuario (opcional)
  async deleteUser(userId) {
    try {
      await deleteDoc(doc(db, 'usuarios', userId));
      return { success: true };
    } catch (error) {
      return { success: false, error: error.message };
    }
  }
};